// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

export const isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdAppEmbedResult = objectOf({
  app_embed_active: anyOf(nullOrUndefined, boolean),
  theme_url: anyOf(nullOrUndefined, string),
});
